import React, { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import { BiTrash } from 'react-icons/bi';
import Modal from './extraModal/AchieveModal'
import { arrayForSelect } from '../../../utils/arrayForSelect';
import { useSelector } from 'react-redux';
import CustomSelect from '../../../components/CustomSelect';


export default function IssuedDocuments() {

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { issued_documents: issuedData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)
  const [year, setYear] = useState(null)

  useEffect(() => {
    const dataJson = JSON.stringify(issuedData)
    if (!addMode && issuedData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        issued_documents: [...issuedData]
      }))
      if (updateInitialValues) {
        updateInitialValues('issued_documents', issuedData)
      }
    }
  }, [issuedData, addMode, setValues, updateInitialValues])

  const handleYearChange = (name, value) => {
    setYear(value)
  }

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.id) {
      const newItem = {
        ...itemData,
        id: `new_${Date.now()}`
      }
      setFieldValue('issued_documents', [...(values.issued_documents || []), newItem])
    } else {
      const updated = (values.issued_documents || []).map(item =>
        item.id === itemData.id ? itemData : item
      )
      setFieldValue('issued_documents', updated)
    }
    setTimeout(() => allForms.handleSubmit(), 0)
    closeModal()
  }

  const handleDeleteItem = (itemId) => {
    if (!String(itemId).startsWith('new_')) {
      trackDeletion('issued_documents', itemId)
    }
    const filtered = (values.issued_documents || []).filter(item => item.id !== itemId)
    setFieldValue('issued_documents', filtered)
  }

  const renderLi = (item) => {
    const { id, date, doc_type, series, number, specialty, whogave, hours, note } = item
    return (
      <tr key={id} onClick={openModal(item)}>
        <td>{date || ''}</td>
        <td>{doc_type || ''}</td>
        <td>{series || ''}</td>
        <td>{number || ''}</td>
        <td>{specialty || ''}</td>
        <td>{whogave || ''}</td>
        <td>{hours || ''}</td>
        <td>{note || ''}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      }

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный год'
            valuesName="year"
            options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
            width='120px'
            value={year}
            setFieldValue={handleYearChange}
          />
        </div>
        <Table className={styles.table} >
          <thead>
            <tr>
              <th>Дата</th>
              <th>Вид документа</th>
              <th>Серия</th>
              <th>Номер</th>
              <th>Специальность</th>
              <th>Кто выдал</th>
              <th>Сколько часов</th>
              <th>Примечание</th>
            </tr>
          </thead>
          <tbody>
            {values.issued_documents?.map(renderLi)}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

